module.exports = __webpack_public_path__ + "static/media/mic_off.4f0db380.svg";